var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1511_10569)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5385,
    cy: 34.8431,
    rx: 34.8431,
    ry: 34.8431,
    fill: "#012269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8816 34.8431C68.8816 53.258 53.9534 68.1863 35.5385 68.1863C17.1235 68.1863 2.19531 53.258 2.19531 34.8431C2.19531 16.4282 17.1235 1.5 35.5385 1.5C53.9534 1.5 68.8816 16.4282 68.8816 34.8431Z",
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3472 31.8C40.9473 32.55 40.1973 33.05 39.2973 33.05H32.1473C31.2473 33.05 30.4473 32.55 30.0973 31.8C27.2973 33.65 25.5473 36.85 25.5473 40.3C25.4973 50.5 30.4473 50.5 35.6973 50.5C40.9473 50.5 45.8973 50.5 45.8973 40.3C45.8973 36.85 44.1472 33.65 41.3472 31.8ZM37.7973 44.25C37.3973 44.65 36.8973 44.85 36.1973 44.95V46H35.2973V44.9C34.5473 44.8 33.9972 44.55 33.5972 44.1C33.1972 43.65 32.9973 43.05 32.9973 42.35H34.3472C34.3472 42.8 34.4473 43.2 34.6973 43.45C34.9473 43.7 35.2473 43.85 35.6973 43.85C36.0972 43.85 36.4473 43.75 36.6473 43.55C36.8473 43.35 36.9972 43.1 36.9972 42.75C36.9972 42.45 36.8973 42.15 36.6973 41.95C36.4973 41.75 36.1473 41.55 35.6973 41.4C35.2473 41.25 34.8472 41.1 34.5972 40.95C33.7472 40.5 33.2973 39.8 33.2973 38.9C33.2973 38.3 33.4973 37.8 33.8472 37.4C34.2472 37 34.7473 36.75 35.3973 36.7V35.5H36.2973V36.75C36.9473 36.85 37.4473 37.1 37.7973 37.55C38.1473 38 38.3472 38.6 38.3472 39.3H36.9972C36.9972 38.85 36.8973 38.45 36.6973 38.2C36.4973 37.95 36.1973 37.8 35.8472 37.8C35.4972 37.8 35.1973 37.9 34.9973 38.1C34.7973 38.2 34.6973 38.5 34.6973 38.85C34.6973 39.15 34.7973 39.45 34.9973 39.6C35.1973 39.8 35.5472 40 35.9972 40.15C36.4472 40.3 36.8472 40.5 37.0972 40.65C37.3472 40.8 37.5973 40.95 37.7973 41.15C37.9973 41.35 38.1472 41.55 38.2472 41.8C38.3472 42.05 38.3973 42.35 38.3973 42.7C38.3973 43.35 38.1973 43.85 37.7973 44.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6424 29.05V30.75C40.6424 31.5 40.0424 32.1 39.2924 32.1H32.1424C31.3924 32.1 30.7924 31.5 30.7924 30.75V29.05C30.7924 28.3 31.3924 27.7 32.1424 27.7H39.2924C39.9924 27.7 40.6424 28.3 40.6424 29.05ZM42.6424 20.15L40.0924 26.9C39.8424 26.8 39.5424 26.75 39.2424 26.75H32.1424C31.8424 26.75 31.5424 26.8 31.2924 26.9L28.7424 20.15C28.6424 19.95 28.7424 19.7 28.9424 19.55C29.1424 19.4 29.3924 19.45 29.5424 19.6L30.9924 21.1C31.6924 21.8 32.4924 22.15 33.2424 22.05C33.8424 22 34.3424 21.65 34.6924 21.05V21C34.8924 20.6 35.2924 20.35 35.7424 20.35C36.1924 20.35 36.5924 20.6 36.7924 21L36.8924 21.15C37.1924 21.75 37.6924 22.1 38.3424 22.15C39.1424 22.25 39.9924 21.85 40.6924 21C41.3424 20.25 41.8424 19.65 41.8424 19.65C41.9924 19.45 42.2424 19.4 42.4424 19.55C42.6424 19.7 42.7424 19.95 42.6424 20.15Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1511_10569",
    x: 0.695312,
    y: 0,
    width: 69.6875,
    height: 72.6863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.133333 0 0 0 0 0.411765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1511_10569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1511_10569",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinBtn);
export default __webpack_public_path__ + "static/media/coin-btn.cf616d4ab8713c494621a20f1b42d88e.svg";
export { ForwardRef as ReactComponent };